import type { CreativeClass } from '@feathr/blackbox';
import { META_CREATIVE_CLASSES } from '@feathr/blackbox';
import type { TChannel } from '@feathr/extender/components/Creatives/types';

/**
 * Derives the selected channel from a creative class filter.
 *
 * @param clsFilter - Array of creative classes from the filter
 * @returns 'display' if only display classes, 'meta' if only meta classes, undefined if mixed or empty
 */
export function getSelectedChannel(clsFilter?: CreativeClass[]): TChannel | undefined {
  if (!clsFilter || clsFilter.length === 0) {
    return undefined;
  }

  const metaClasses = META_CREATIVE_CLASSES as readonly CreativeClass[];
  const hasMeta = clsFilter.some((cls) => metaClasses.includes(cls));
  const hasDisplay = clsFilter.some(
    (cls) => !metaClasses.includes(cls) && cls.startsWith('Creative.Display'),
  );

  if (hasMeta && !hasDisplay) {
    return 'meta';
  }
  if (hasDisplay && !hasMeta) {
    return 'display';
  }
  return undefined;
}
